import { BreadcrumbLink, Breadcrumbs } from "@synota-io/synota-shared-ui";
import { NODES_PATH, NODE_DETAILS_PATH } from "../../../paths";
import { getUrlTitle } from "../utils";
import { useParams, ParamParseKey } from "react-router-dom";
import { useNodeUrls } from "../../../api/hooks/useNodeUrls";

export const NodesBreadcrumbs = () => {
  const { nodeUuid = "" } = useParams<ParamParseKey<typeof NODE_DETAILS_PATH>>();

  const { nodeUrls } = useNodeUrls();

  const links: BreadcrumbLink[] = [{ label: "Nodes", path: NODES_PATH }];

  const find = nodeUrls.find((node) => node.uuid === nodeUuid);

  if (find) {
    links.push({ label: getUrlTitle(find.api_url), path: NODE_DETAILS_PATH, params: { nodeUuid } });
  }

  return <Breadcrumbs links={links} />;
};
